import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';

import type { TOC } from '@ember/component/template-only';

export interface BvPopoverFooterSignature {
  Args: {
    popover?: Dropdown;
  };
  Blocks: {
    default: [popover?: Dropdown];
  };
  Element: HTMLElement;
}

const BvPopoverFooterComponent: TOC<BvPopoverFooterSignature> = <template>
  <footer class='bv-popover__footer' ...attributes>
    {{yield @popover}}
  </footer>
</template>;

export default BvPopoverFooterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvPopover::Footer': typeof BvPopoverFooterComponent;
    'bv-popover/footer': typeof BvPopoverFooterComponent;
  }
}
